import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CryptoCurrency, CurrencyTypeTextsResponse, DepositData, EstimatePriceData } from 'src/types/responses/crypto-responses';
import { CryptProcessService } from '../../services/crypt-process.service';
import { ICountry, IUserDetailsState } from 'src/app/store/user-details/user-details.state';
import { Store } from '@ngrx/store';
import { selectUserDetailsData } from 'src/app/store/user-details/user-details.selectors';
import { DepositRequest, EstimatePriceRequest } from 'src/types/requests/crypto-requests';
import { CurrencyNetwork, CurrencyTypeTexts } from 'src/app/helpers/cryptoHelper';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
@Component({
  selector: 'crypto-deposit',
  templateUrl: 'crypto-deposit.component.html',
  styleUrls: ['crypto-deposit.component.scss'],
})
export class CryptoDepositComponent implements OnInit {
  step: 'step-1' | 'step-2' | 'step-3' | 'step-4' = 'step-1';
  cryptoType: string;
  selectedCrypto: CryptoCurrency | null = null;
  cryptoCurrencies: CryptoCurrency[];
  currentCurrency : ICountry;
  depositData: DepositData;
  estimatePriceData: EstimatePriceData;
  currencyTypeTexts: CurrencyTypeTextsResponse;
  
  // Amount related properties
  amount: number = null;
  minAmount: number = 100;
  maxAmount: number = 10000000000;
  amountError: string = '';
  currencyRate: number = 0;
  
  // QR Code width - responsive
  qrCodeWidth: number = 300;

  constructor(
    private translateService: TranslateService,
    private cryptProcessService: CryptProcessService,
    private store: Store<IUserDetailsState>,
    public config: DynamicDialogConfig,
  ) {
    // Mobilde modal genişliğini %90 yap ve QR code genişliğini ayarla
    if (window.innerWidth <= 768) {
      this.config.width = '90vw';
      this.config.contentStyle = {
        ...this.config.contentStyle,
        'max-width': '90vw',
      };
      this.qrCodeWidth = window.innerWidth <= 480 ? 200 : 250;
    }
    this.store.select(selectUserDetailsData).subscribe((user) => {
      this.currentCurrency = user.country;
    });
  }

  estimatePrice(amount: number) {
    const request: EstimatePriceRequest = {
      amount: amount,
      from: this.selectedCrypto.currencyShortCode,
      to: this.currentCurrency.currency,
    };
    
    this.cryptProcessService.estimatePrice(request).subscribe((res) => {
      this.estimatePriceData = res.data;
      
      this.currencyRate = parseFloat(this.estimatePriceData.estimated_amount);
    });
  }

  ngOnInit() {
    this.getCryptoCurrencies();
  }

  selectCryptoType(crypto: CryptoCurrency) {
    this.selectedCrypto = crypto;
    this.estimatePrice(1);
  }

  confirm() {
    this.step = 'step-3';
    
    const request: DepositRequest = {
      priceCurrencyId: this.currentCurrency.id,
      payCurrencyId: this.selectedCrypto.id,
      priceAmount: this.amount,
    };
    this.cryptProcessService.createDeposit(request).subscribe((res) => {
      this.depositData = res.data;
    }, () => {
      this.step = 'step-2';
    });
  }

  continue() {
    if(!this.selectedCrypto) {
      return;
    }

    if (!this.validateAmount()) {
      return;
    }

    this.step = 'step-2';
  }

  async getCryptoCurrencies() {
    return await this.cryptProcessService.getCryptoCurrencies().subscribe((res) => {
      this.cryptoCurrencies = res.data;

      if (!this.selectedCrypto) {
        this.selectedCrypto = this.cryptoCurrencies?.[0];
        this.selectCryptoType(this.selectedCrypto);
      }
    });
  }

  validateAmount(): boolean {
    this.amountError = '';
    
    if (!this.amount) {
      this.amountError = 'CRYPTO.AMOUNT_REQUIRED';
      return false;
    }
    
    if (this.amount < this.selectedCrypto?.minDepositAmount) {
      this.amountError = 'CRYPTO.AMOUNT_TOO_LOW';
      return false;
    }
    
    return true;
  }

  onAmountChange() {
    this.amountError = '';
  }

  parseFloat(value: any): number {
    return parseFloat(value);
  }
}
